<div class="job-rejected-page">
  @if (carrierData?.companyLogo) {
    <div class="carrier-logo-box">
      <img [src]="carrierData?.companyLogo" alt="Carrier Logo" />
    </div>
  } @else {
    <div class="ellipse-icon">
      <img src="/assets/images/fleetoperate.png" alt="FleetOperate Logo" />
    </div>
  }


  <div class="headline">🚫 Applications Currently Closed</div>

  <div class="message-text">
    We are not accepting new driver applications at this time.
    <br /><br />
    Thank you for your interest in joining our team at
    <span class="company-name">{{ carrierData?.companyName || 'our company' }}</span>
  </div>

  <div class="info-box">
    <ul>
      <li>
        You can still keep your <strong>FleetOperate</strong> Driver Profile updated and ready.
      </li>
      <li>
        You can apply to <strong>other carriers</strong> on the FleetOperate network at any time.
      </li>
    </ul>
  </div>

  <button mat-raised-button class="sign-in-button" (click)="onNavigateToSignIn()">Sign in</button>

  <button mat-raised-button class="sign-up-button" (click)="onNavigateToSignUp()">Sign up</button>

  <div class="footer">
    <span>Powered by</span>
    <img src="/assets/images/fleetoperate-logo.png" alt="FleetOperate Logo" />
  </div>
</div>